import React from "react";
import Iframe from "react-iframe";

function Map() {
  return (
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3798.29722711757!2d31.045545081841446!3d-17.824696232723316!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1931a4e3d3569787%3A0x8993db5f5973ec78!2sCoghlan%20Welsh%20%26%20Guest!5e0!3m2!1sen!2ske!4v1681742803221!5m2!1sen!2ske"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      className="w-full h-full"
      title="Coghlan, Welsh & Guest Location"
    />
  );
}

export default Map;
